export default __webpack_public_path__ + "static/media/CIJEANS.2f01f45a.png";